//

import createCachedSelector from "re-reselect"
import { List, Map } from "immutable"

export function selectSearchState(state, props) {
    return state.search
}

export function selectSearchifyState(state, props) {
    return selectSearchState(state, props).getIn(["filterableListViews", props.uniqueFlvId, "searchify"], Map())
}

export function selectSearchifySlice(sliceName, defaultGet = null) {
    return createCachedSelector(selectSearchifyState, (state) => state.get(sliceName, defaultGet))(
        (state, props) => props.uniqueFlvId,
    )
}

export const selectSearchifyLabelStack = (state, props) =>
    // slice(0, -1) returns all elements save for the last one
    selectSearchState(state, props).get("searchifyLabelStack").slice(0, -1)

export const selectSearchifyLabelStackLabel = createCachedSelector(selectSearchifyLabelStack, (labelStack) => {
    const previousSearchifyDataType = labelStack.size && labelStack.slice(-1).get(0)

    return previousSearchifyDataType && previousSearchifyDataType.substring(0, previousSearchifyDataType.indexOf("-"))
})((state, props) => props.uniqueFlvId)

export const selectSearchifyRouteDetails = (state, props) =>
    selectSearchState(state, props).get("searchifyPathStack", List()).last()

export const selectSearchifyOriginDetails = (state, props) =>
    selectSearchState(state, props).get("searchifyOriginDetails") || Map()

export const selectSearchifyPathStackSize = (state, props) =>
    selectSearchState(state, props).get("searchifyPathStack").size

/** ****************************************************************************
 *
 * Inline select logic!
 *
 ****************************************************************************** */

export const selectIsInlineSearchifySelected = createCachedSelector(
    [selectSearchifyState, (state, props) => props.datum],
    (searchifySlice, datum) => {
        // if it's filter only, then the inlines should never be
        // visually selected
        if (searchifySlice.get("filterOnlySearchify", false)) {
            return false
        }

        const id = datum.get("id")
        const isSelected = datum.get("is_searchify_selected", false)
        const inAddedIds = searchifySlice.getIn(["searchifyFilters", "addedIds"], List()).includes(id)
        const inDeletedIds = searchifySlice.getIn(["searchifyFilters", "deletedIds"], List()).includes(id)
        return (inAddedIds || isSelected) && !inDeletedIds
    },
)((state, props) => `${props.uniqueFlvId},${props.datum.get("id")}`)

/** ****************************************************************************
 *
 * Searchify selects for nested items (searchifyFilters, appearanceValues)
 *
 ****************************************************************************** */

export const selectSearchifyAddedIds = createCachedSelector(selectSearchifyState, (state) =>
    state.getIn(["searchifyFilters", "addedIds"]),
)((state, props) => props.uniqueFlvId)

export const selectSearchifyQuerysetList = createCachedSelector(selectSearchifyState, (state) =>
    state.getIn(["searchifyFilters", "querysetList"]),
)((state, props) => props.uniqueFlvId)

export const selectSearchifyCount = createCachedSelector(selectSearchifyState, (state) =>
    state.getIn(["searchifyFilters", "searchifyCount"]),
)((state, props) => props.uniqueFlvId)

export const selectSearchifyShowingCurrentSelection = createCachedSelector(selectSearchifyState, (state) =>
    state.getIn(["appearanceValues", "searchifyShowingCurrentSelection"]),
)((state, props) => props.uniqueFlvId)

export const selectIsSearchifyCountLoading = createCachedSelector(selectSearchifyState, (state) =>
    state.getIn(["appearanceValues", "searchifyCountIsLoading"], false),
)((state, props) => props.uniqueFlvId)

export const selectSearchifyHasSelectedAll = createCachedSelector(selectSearchifyState, (state) =>
    state.get("hasSelectedAll"),
)((state, props) => props.uniqueFlvId)

/** ****************************************************************************
 *
 * Searchify selects for non-nested items
 *
 ****************************************************************************** */

export const selectIsSearchifySubmittable = selectSearchifySlice("isSearchifySubmittable", false)

export const selectIsSearchifySelectAllDisabled = selectSearchifySlice("selectAllDisabled", false)
export const selectIsSearchifySelectAllActionButtonEnabled = selectSearchifySlice("selectAllActionButtonEnabled", false)

// export const selectSearchifyFilters = (uniqueFlvId: string) =>
//     selectSearchifySlice("searchifyFilters")

// export const selectSubmitSearchifyFunc = (uniqueFlvId: string) =>
//     selectSearchifySlice("submitSearchifyFunc")

// export const selectSimpleSubmitSearchifyFunc = (uniqueFlvId: string) =>
//     selectSearchifySlice("simpleSubmitSearchifyFunc")

// export const selectNeedSearchifyCountUpdate = (uniqueFlvId: string) =>
//     selectSearchifySlice("needSearchifyCountUpdate", false)

export const selectSearchifyHeaderName = selectSearchifySlice("searchifyHeaderName")

// export const selectIsSingleSelectSearchify = (uniqueFlvId: string) =>
//     selectSearchifySlice("singleSelectSearchify", false)

export const selectIsFilterOnlySearchify = selectSearchifySlice("filterOnlySearchify", false)

// export const selectIsSearchifyClickInlineMode = (uniqueFlvId: string) => createSelector(
//     selectSearchifyStateuniqueFlvId,
//     state => state.get("isSearchifySubmittable") && state.get("isSearchifyClickInlineMode")
// )

// export const selectSearchSubmitLanguage = (uniqueFlvId: string) => createSelector(
//     selectSearchifyStateuniqueFlvId,
//     state => state.get('searchifySubmitLanguage', Immutable.Map()).toJS()
// )
